import { useState } from "react";
import { hitApi } from "../utils/apiCall";

function useGetStaffAttendanceReport() {
  const [staffAttErr, setStaddAttErr] = useState();
  const [loadingStaffAtt, setLoadingStaffAtt] = useState(false);
  const [staffAtt, setStaffAtt] = useState(null);

  async function getStaffAttendanceReport(month, empId, roleId) {
    // console.log(mont
    // h, empId, roleId);

    if (!month || !empId) {
      setStaffAtt([]);
      return;
    }

    setStaddAttErr(null);
    setLoadingStaffAtt(true);

    const fd = new FormData();
    fd.append("month", month?.split("-").reverse().join("-"));
    fd.append("roleId", 1);

    if (Array.isArray(empId) && empId.length > 0) {
      empId.forEach((emp) => fd.append("staffId[]", emp));
    } else if (empId) {
      fd.append("staffId[]", empId);
    }
    fd.append("authToken", localStorage.getItem("authToken") || "");
    // fd.forEach((v, k) => console.log(k, v));
    try {
      const response = await hitApi(
        "reports/attedance",
        "staffAttendanceOfMonth",
        fd
      );
      // console.log(response);

      if (response.data && Array.isArray(response.data)) {
        setStaffAtt(response.data);
      } else {
        setStaffAtt([]);
      }
    } catch (err) {
      console.error("Error fetching employees:", err);
      setStaddAttErr(err);
      setStaffAtt([]);
    } finally {
      setLoadingStaffAtt(false);
    }
  }
  return { staffAttErr, loadingStaffAtt, staffAtt, getStaffAttendanceReport };
}

export default useGetStaffAttendanceReport;
